import request from 'services/axios';

export function httpGetCompanies(params) {
  return request.get('/api/companies/', { params });
}

export function httpGetCompany(id) {
  return request.get(`/api/companies/${id}/`);
}

export function httpPostCompany(dto) {
  return request.post('/api/companies/', dto);
}

export function httpPutCompany({ id, ...dto }) {
  return request.put(`/api/companies/${id}/`, dto);
}

export function httpPatchCompany({ id, ...dto }) {
  return request.patch(`/api/companies/${id}/`, dto);
}

export function httpDeleteCompany(id) {
  return request.delete(`/api/companies/${id}/`);
}
